module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('section', {
    attrs: {
      "id": "content_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('ul', _vm._l((_vm.tabItem), function(tab) {
    return _c('li', {
      class: _vm.tabIndex === tab.idx ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.changeTabItem(tab.idx)
        }
      }
    }, [_c('a', [_c('span', [_vm._v(_vm._s(tab.name))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "point_wrap white_box"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top",
    style: (_vm.tabIndex === 0 ? _vm.pointBg : _vm.tableBg)
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 0),
      expression: "tabIndex===0"
    }],
    staticClass: "pointsSumm"
  }, [_c('h4', [_vm._v("消费积分")]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('p', {
    staticClass: "layerCol"
  }, [_vm._v("\n                可用积分："), _c('strong', [_vm._v(_vm._s(_vm.costPoint))]), _vm._v("\n                冻结积分："), _c('strong', [_vm._v(_vm._s(_vm.freezePoint))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 1),
      expression: "tabIndex===1"
    }]
  }, [_c('Table', {
    staticClass: "order-table",
    attrs: {
      "columns": _vm.point.column,
      "data": _vm.point.list,
      "no-data-text": "尚无积分"
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.point.total,
      "show-total": "",
      "show-elevator": "",
      "current": _vm.point.pageIndex,
      "page-size": _vm.pageSize
    },
    on: {
      "on-change": _vm.changePointPage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 2),
      expression: "tabIndex===2"
    }]
  }, [_c('Table', {
    staticClass: "order-table",
    attrs: {
      "columns": _vm.freeze.column,
      "data": _vm.freeze.list,
      "no-data-text": "尚无冻结积分"
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.freeze.total,
      "show-total": "",
      "show-elevator": "",
      "current": _vm.freeze.pageIndex,
      "page-size": _vm.pageSize
    },
    on: {
      "on-change": _vm.changeFreezePage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("我的积分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg"
    }
  }), _vm._v(" "), _c('div', [_c('b', [_vm._v("积分规则:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("当积分已达到某一兑换积分标准时，顾客可将累计积分依照网站相应积分及兑换标准兑换回馈商品，网站将即时从用户会员积分中扣减相应积分。")]), _vm._v(" "), _c('li', [_vm._v("各项回馈项目（包含各项商品、服务或抵用券等）及兑换标准及兑换规则均以兑换当时最新回馈活动公告或目录为准。")]), _vm._v(" "), _c('li', [_vm._v("部分兑换商品有数量限制的，兑完为止。")]), _vm._v(" "), _c('li', [_vm._v("公告或目录如有有效期限的，逾期即不得兑换。")]), _vm._v(" "), _c('li', [_vm._v("积分兑换区的商品为只可用积分兑换的商品(如积分价格：100积分)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b95ef7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/point.vue
// module id = 1524
// module chunks = 1